
export const RESEARCHER_DETAILS_LINK = 'https://app.dimensions.ai/discover/publication?and_facet_researcher=';
export const GOOGLE_SEARCH = 'https://www.google.com/search?q=';
export const ORCID_LINK = 'https://orcid.org/';
export const DOI_LINK = 'https://doi.org/';

export function researcherLink(researcher_id) {
    return RESEARCHER_DETAILS_LINK + researcher_id;
}

export function googleSearchLink(query) {
    return GOOGLE_SEARCH + query;
}

export function orcidLink(orcid_id) {
    return ORCID_LINK + orcid_id;
}

export function doiLink(doi) {
    return DOI_LINK + doi;
}